/**
 * KAN-811: смена пароля входа менеджера: поле "Новый пароль" и "Сохранить".
 * Компонент только собирает пароль; сохранение делает вызывающий.
 */
import { useEffect, useId, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  open: boolean;
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onSave: (password: string) => void;
}

export function ManagerPasswordDialog({ open, pending, error, onClose, onSave }: Props): JSX.Element {
  const [password, setPassword] = useState('');
  const inputId = useId();
  useEffect(() => {
    if (open) setPassword('');
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Сменить пароль</DialogTitle>
          <DialogDescription>Менеджер войдёт в кабинет с новым паролем.</DialogDescription>
        </DialogHeader>
        <form
          className="space-y-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (password) onSave(password);
          }}
        >
          <Label htmlFor={inputId}>Новый пароль</Label>
          <Input
            id={inputId}
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <p className="text-sm text-red-700" role="alert">
              {error}
            </p>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Отмена
            </Button>
            <Button type="submit" disabled={!password || pending}>
              Сохранить
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
